import React, { useCallback, useMemo } from 'react';
import { View } from 'react-native';
import Animated from 'react-native-reanimated';
import { FlashList } from '@shopify/flash-list';
import { useAppSelector } from 'store/hooks';
import { AppView, Indicator, withAnimatedNavigationHeader } from 'design-system';
import { SCREEN_BOTTOM_PADDING, SCROLL_INDICATOR_INSETS } from 'design-system/values';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMarginBottom } from 'hooks/useMarginBottom';
import { extractKeyFromKey } from 'utils/flatListHelpers';
import EmptyState from '../components/EmptyState';
import AutoinvestActivityRowItem from '../components/AutoinvestActivityItem';
import useAutoInvestActivities from '../hooks/useAutoInvestActivities';
import { selectActiveTradingAccountId } from '../reducers/selectors';
import { isWeb } from '../../../constants';
const AnimatedFlashList = Animated.createAnimatedComponent(FlashList);
const AutoinvestActivitiesScreen = withAnimatedNavigationHeader(({ scrollHandler }) => {
    const accountId = useAppSelector(selectActiveTradingAccountId);
    const [flashListData, onLoadNextPage, initialLoading] = useAutoInvestActivities(accountId);
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const contentContainerStyles = useMarginBottom('paddingBottom', SCREEN_BOTTOM_PADDING, paddingHorizontalStyle);
    const hasData = !!flashListData?.length;
    const renderItem = useCallback(({ item }) => <AutoinvestActivityRowItem activity={item}/>, []);
    const content = useMemo(() => {
        if (initialLoading && !hasData) {
            return <Indicator dark/>;
        }
        if (!hasData) {
            return (<View style={paddingHorizontalStyle}>
              <EmptyState activity subtitle="Your autoinvest activities will show here"/>
            </View>);
        }
        return (<AnimatedFlashList data={flashListData} renderItem={renderItem} scrollEventThrottle={16} onScroll={scrollHandler} showsVerticalScrollIndicator onEndReached={onLoadNextPage} keyExtractor={extractKeyFromKey('id')} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS} contentContainerStyle={contentContainerStyles}/>);
    }, [
        initialLoading,
        hasData,
        flashListData,
        renderItem,
        scrollHandler,
        onLoadNextPage,
        contentContainerStyles,
        paddingHorizontalStyle,
    ]);
    return <AppView withFrame={false}>{content}</AppView>;
}, ({ colors }) => ({
    title: 'Activity',
    headerColorOutputRange: [colors.background.dark, colors.cards.onDark],
}));
export default AutoinvestActivitiesScreen;
